export const deliveryMethodSchema = `
        transferPartner
        fees {
            amount
            calculationType
        }
        value
        label
        description
        transferLimit
        cashPickupBanks {
            name
            sortCode
            shortCode
            status
        }
        selectedCashPickupBank {
            name
            sortCode
            status
        }
    `;
